import { render, staticRenderFns } from "./SchemePlanApplicationDetails.vue?vue&type=template&id=72d4b41e"
import script from "./SchemePlanApplicationDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./SchemePlanApplicationDetails.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports